import { render, staticRenderFns } from "./Portfolio.vue?vue&type=template&id=b1642e2a&scoped=true"
import script from "./Portfolio.vue?vue&type=script&lang=js"
export * from "./Portfolio.vue?vue&type=script&lang=js"
import style0 from "./portfolio.css?vue&type=style&index=0&id=b1642e2a&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1642e2a",
  null
  
)

export default component.exports